export class FlyoutMenu {
  constructor() {
    this.init();
    this.dropdowns();
    let mql = window.matchMedia('(max-width: 1199px)');
    this.mobile(mql);
    mql.addEventListener('change', this.mobile);
  }

  init() {
    var $flyoutMenu = $('.header-menu--more--flyout');
    $flyoutMenu.addClass('inactive');
    $('.header-menu--more--toggle').on('click', function (e) {
      e.preventDefault();
      $flyoutMenu.removeClass('inactive');
      $flyoutMenu.removeClass('header-menu__flyout--hidden');
      $(this).parent().addClass('open');
      $('body').css({ overflow: 'hidden' });
      $(this).attr('aria-expanded', true);

      // Close search if open.
      const $searchContent = $('.header-menu--search--content');
      if ($searchContent.length && !$searchContent.hasClass('inactive')) {
        $('.header-menu--search.open').removeClass('open');
        $searchContent.addClass('inactive');
        $('.header-menu--search--background').removeClass('active');
      }
    });

    $('.header-menu--more--overlay, .header-menu--more--close').on(
      'click',
      function (e) {
        e.preventDefault();
        $('.header-menu--more').removeClass('open');
        $('body').css({ overflow: 'auto' });
        let mql = window.matchMedia('(max-width: 1199px)');
        if (mql.matches) {
          $flyoutMenu.one('transitionend', function () {
            $flyoutMenu.addClass('inactive');
          });
        }
        $('.header-menu--more--toggle').attr('aria-expanded', false);
        $flyoutMenu.addClass('inactive');
      }
    );
  }

  mobile(mql) {
    if (mql.matches) {
      var $flyoutMenu = $('.header-menu--more--flyout');
      $flyoutMenu.removeClass('inactive');
    }
  }

  dropdowns() {
    var $flyoutDropdownMenu = $('.header-menu--more .level-1 ul');
    $flyoutDropdownMenu.addClass('inactive');
    $('.header-menu--more .level-1 .has-children').each(function () {
      $(this).attr('aria-haspopup', true).attr('aria-expanded', false);
    });
    $('.header-menu--more .level-1 .has-children').on(
      'click keyup',
      function (e) {
        e.preventDefault();
        if (e.type == 'keyup' && e.keyCode != 13) {
          return;
        } else if (e.type == 'click') {
          var x = e.x || e.clientX;
          var y = e.y || e.clientY;
          if (!x && !y) {
            return false;
          }
        }
        let children = $(this).siblings('ul, .dropdown');
        $(this).toggleClass('open');
        if ($(this).hasClass('open')) {
          $(this).attr('aria-expanded', true);
          $flyoutDropdownMenu.removeClass('inactive');
          /* istanbul ignore next - No need to test gsap */
          gsap.to(children, {
            duration: 1,
            ease: 'power4.out',
            height: 'auto',
            onComplete: function () {
              $flyoutDropdownMenu.removeClass('inactive');
            },
          });
        } else {
          $(this).attr('aria-expanded', false);
          /* istanbul ignore next - No need to test gsap */
          gsap.to(children, {
            duration: 0.5,
            ease: 'power4.out',
            height: 0,
            onComplete: function () {
              $flyoutDropdownMenu.addClass('inactive');
            },
          });
        }
      }
    );
  }
}
